<template>
  <!-- cookie列表抽屉 -->
  <a-drawer
    title="cookie设置"
    width="900"
    :closable="false"
    :visible="visible"
    @close="onClose"
  >
    <!-- 新建按钮 -->
    <div style="margin-bottom: 16px; text-align: right;">
      <a-button type="primary" @click="touchAdd">新建</a-button>
    </div>
    <!-- 列表 -->
    <a-table
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :loading="isLoading"
      :pagination="false"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <!-- 操作 -->
        <template v-if="column.key === 'operation'">
          <a class="operation-item" @click="touchEdit(record)">编辑</a>
        </template>
        <template v-else>{{ record[column.key] || '-' }}</template>
      </template>
    </a-table>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
    <!-- cookie编辑弹窗 -->
    <Cookie ref="RefCookie" @success="getList"></Cookie>
  </a-drawer>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Cookie from './Cookie.vue'
import { cookieList } from '@/api/copyright'

// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// Cookie组件引用
let RefCookie = ref(null)
// 数据源
let dataSource = ref([])
// 列数据源
let columns = ref([
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '主体名称',
    dataIndex: 'entity_name',
    key: 'entity_name'
  },
  // {
  //   title: 'cookie',
  //   dataIndex: 'cookie',
  //   key: 'cookie'
  // },
  {
    title: '过期状态',
    dataIndex: 'is_expire_text',
    key: 'is_expire_text'
  },
  {
    title: '过期时间',
    dataIndex: 'expire_date',
    key: 'expire_date'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 打开抽屉
function showDrawer () {
  visible.value = true
  getList()
}

// 关闭抽屉
function onClose () {
  visible.value = false
  dataSource.value = []
}

// 获取列表
function getList () {
  isLoading.value = true
  cookieList().then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      // 如果返回的是数组，直接使用；如果是对象包含data字段，使用data
      dataSource.value = Array.isArray(data) ? data : (data?.data || [])
    } else {
      message.error(res.message || msg)
    }
  }).catch(err => {
    isLoading.value = false
    message.error(err.message || '获取列表失败')
  })
}

// 新建
function touchAdd () {
  RefCookie.value.showDrawer()
}

// 编辑
function touchEdit (record) {
  RefCookie.value.showDrawer(record.id)
}

// 暴露出去
defineExpose({
  showDrawer
})
</script>

<style lang="less" scoped>
.operation-item {
  margin-right: 16px;
  cursor: pointer;
  color: #1890ff;
}
.operation-item:hover {
  color: #40a9ff;
}
</style>

